import Model from '@/models/Model'

export default class GCoreBusinessSii extends Model {
    resource() {
        return 'g_core_business_sii'
    }
}
